import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const HEADLINE = {
  field: 'head_line',
  header: 'Head Line',
  responsive: 'sm',
};

const DESCRIPTION = {
  field: 'description',
  header: 'Description',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed On',
};

export const CarouselAdActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/carouselads/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      api={`/carousel-ads`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      search={searchValue}
      searchFields={'head_line'}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-carousel-ad', row);
      }}
      columns={[
        CREATEDON,
        HEADLINE,
        DESCRIPTION,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const CarouselAdCompletedTable = props => {
  const {
    route: {params},
    searchValue,
  } = props;
  const {communicationFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={'head_line'}
      api={`/carousel-ads`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      params={params}
      columns={[CREATEDON, HEADLINE, DESCRIPTION, COMPLETEDON]}
    />
  );
};
